const { CERTIFICATIONS } = require('./Constant')

export const certificatesToSports = (certificates) => {
  const sports = new Set()
  certificates.forEach((cert) => {
    if (cert.startsWith('CASI')) {
      sports.add('SNOWBOARD')
    } else if (cert.startsWith('CSIA')) {
      sports.add('SKI')
    } else if (cert.startsWith('MTB')) {
      sports.add('MOUNTAIN_BIKE')
    } else {
      sports.add('OTHERS')
    }
  })
  return Array.from(sports)
}

export const CERTIFICATIONS_UPPER_CASE = CERTIFICATIONS.map((certificate) => certificate.toUpperCase())

export const isValidCertificate = (certificate) => {
  return CERTIFICATIONS_UPPER_CASE.includes(certificate.toUpperCase())
}

export const isInstructor = (user) => {
  return user?.roles?.includes('INSTRUCTOR')
}

export const isStudent = () => {
  return true
}

export const isAdmin = (user) => {
  return user?.roles?.includes('ADMIN')
}

export const isOwner = (user, session) => {
  if (!user || !session) return false
  return user?.resourceId === session.instructorId || user?.resourceId === session.ownerId
}

/**
 * Convert participantIds to participants
 * A method needs during the migration from participantIds to participants
 * @param {Array<string>} participantIds - Array of participant IDs
 * @returns {Array<Object>} - Array of participants
 */
export const participantIdsToParticipants = (participantIds = []) => {
  const participants = []
  for (const id of participantIds) {
    participants.push({ id, familyId: 0 })
  }
  return participants
}

/**
 * Get participants from session
 * A method needs during the migration from participantIds to participants
 * @param {Object} session - Session object
 * @returns {Array<Object>} - Array of participants
 */
export const getParticipants = (session) => {
  const participants = session.participants || []
  const potentialParticipants = participantIdsToParticipants(session.participantIds || [])

  for (const pp of potentialParticipants) {
    if (!participants.some((p) => isSameParticipant(p, pp))) {
      participants.push(pp)
    }
  }

  return participants
}

export const getUserName = (user) => {
  return `${user.firstName} ${user.lastName || ''}`.trim()
}

export const isParticipant = (user, session) => {
  if (!user?.resourceId) return false

  if (session.participantsId?.includes(user?.resourceId)) {
    return true
  }

  return session.participants?.some((participant) => participant.id === user?.resourceId)
}

export const isSameParticipant = (participantA, participantB) => {
  if (!participantA || !participantB) return false

  if (participantA.id !== participantB.id) {
    return false
  }

  const familyIdA = participantA.familyId || 0
  const familyIdB = participantB.familyId || 0

  if (familyIdA !== familyIdB) {
    return false
  }

  return true
}

// Helper function to check if token is expired
export const isTokenExpired = (token) => {
  if (!token) return true
  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    )
    const { exp } = JSON.parse(jsonPayload)
    return exp * 1000 < Date.now()
  } catch (error) {
    console.error('Error parsing token:', error)
    return true
  }
}

export const isServerImage = (imageUrl) => {
  if (!imageUrl) return false
  // Update, the image url is https://img.bookingonsnow.com/images
  if (imageUrl.includes('img.bookingonsnow.com/images')) {
    return true
  }
  return false
}
